let mapsPromise

export function loadGoogleMaps(apiKey) {
  if (window.google?.maps) return Promise.resolve(window.google.maps)
  if (mapsPromise) return mapsPromise
  if (!apiKey) return Promise.reject(new Error("Google Maps is not configured"))

  mapsPromise = new Promise((resolve, reject) => {
    const callbackName = "__weBuildGoogleMapsReady"
    const script = document.createElement("script")
    const params = new URLSearchParams({ key: apiKey, callback: callbackName, loading: "async" })

    window[callbackName] = () => {
      delete window[callbackName]
      resolve(window.google.maps)
    }

    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`
    script.async = true
    script.onerror = () => {
      delete window[callbackName]
      mapsPromise = undefined
      reject(new Error("Google Maps failed to load"))
    }
    document.head.appendChild(script)
  })

  return mapsPromise
}
